<template>
  <!-- <transition name="modal"> -->
  <div class="game-scaleable-wrapper" id="game-scaleable-wrapper">
    <div class="game-very-specific-design" id="game-very-specific-design" :style="setVerySpecyficDesginStyle()">
      <button type="close" title="Zamknij ćwiczenie" name="close" @click="closeGame()" class="close-button">
        <svg fill="#ffffff" height="55" viewBox="0 0 24 24" width="55" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            fill="rgb(230, 230, 230)"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
      <div class="game-wrapper">
        <tr-game-body>
          <div class="game-body" slot="body">
            <component
              :is="componentEngine"
              :start-game-config="gameConfig"
              :assets="assets"
              :game-id="gameData.id"
            ></component>
          </div>
        </tr-game-body>
        <tr-ui-title
          v-for="(title, index) in gameData.item.title"
          :key="gameData.id + '_' + index"
          class="freePosition"
          :title-text="title.text"
          :audio="title.audio"
          :pos="title.pos"
        ></tr-ui-title>
        <!-- <tr-game-status :gameStatus="actualGameStatus"></tr-game-status> -->
        <!-- <tr-game-status :gameStatus="actualGameStatus"
                      v-show="(!gameData.item.hideControlPanel && !gameConfig.withoutCheck)"></tr-game-status> -->
        <tr-game-status
          :game-status="actualGameStatus"
          v-show="!gameData.item.hideControlPanel && !gameConfig.withoutCheck"
        ></tr-game-status>
        <tr-game-control-panel
          @changeGameStatus="changeGameStatus()"
          v-if="!gameData.item.hideControlPanel"
        ></tr-game-control-panel>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import TrUiTitle from './UI/TrUiTitle/TrUiTitleV2';
import TrGameBody from './TrGameBody/TrGameBodyV2';
import TrGameControlPanel from './UI/TrGameControlPanel/TrGameControlPanelV2';
import TrGameStatus from './UI/TrGameStatus/TrGameStatusV2';
/** gameEngins components */
import TrTestMulti from './GameEngines/TestMulti/TrTestMultiV2';
import TrTestMultiCheckboxImpr from './GameEngines/TestMulti/TrTestMultiCheckboxImprV2';
import TrTestMultiCheckbox from './GameEngines/TestMulti/TrTestMultiCheckboxV2';
import TrMultiCheckboxImpr from './GameEngines/TestMulti/TrMultiCheckboxImprV2';
import TrTestBoolean from './GameEngines/TestBoolean/TrTestBooleanV2';
import TrTextBlockWithInput from './GameEngines/TextBlockWithInput/TrTextBlockWithInputV2';
import TrTextBlockWithInputImpr from './GameEngines/TextBlockWithInput/TrTextBlockWithInputImprV2';
import TrInputOnBackground from './GameEngines/InputOnBackground/TrInputOnBackgroundV2';
import TrInputOnBackgroundGeoDemo5 from './GameEngines/InputOnBackground/TrInputOnBackgroundGeoDemo5';
import TrTestSelectGame from './GameEngines/SelectGame/TrTestSelectGameV2';
import TrSelectGameWithText from './GameEngines/SelectGame/TrSelectGameWithTextV2';
import MpFindWords from './GameEngines/MpFindWords/MpFindWordsV2';
import MpFindWords2 from './GameEngines/MpFindWords/MpFindWords02V2';
import MpModelShow from './GameEngines/MpModel3d/MpModel3dV2';
import MpDraw from './GameEngines/MpDraw/MpDrawV2';
import MpDraw2 from './GameEngines/MpDraw/MpDraw02V2';
import MpDraw3 from './GameEngines/MpDraw/MpDraw03V2';
import MpDraw13 from './GameEngines/MpDraw/MpDraw13V2';
import MpTextSelect from './GameEngines/MpTextSelect/MpTextSelectV2';
import MpChooseAnswer from './GameEngines/MpChooseAnswer/MpChooseAnswerV2';
import MpCrossword from './GameEngines/MpCrossword/MpCrosswordV2';
import MpCrossword2 from './GameEngines/MpCrossword/MpCrossword2V2';
import MpMillionaires from './GameEngines/MpMillionaires/MpMillionairesV2';
import MpMendelejew from './GameEngines/MpMendelejew/MpMendelejewV2';
import MpCompare from './GameEngines/MpCompare/MpCompareV2';
import MpDnD from './GameEngines/MpDnD/MpDnDV2';
import MpDndFree from './GameEngines/MpDnD/MpDnDFreeV2';
import MpDndFree2 from './GameEngines/MpDnD/MpDnDFree2V2';
import MpSortable from './GameEngines/MpSortable/MpSortableV2';
import MpSortableMulti from './GameEngines/MpSortable/MpSortableMultiV2';
import MpRotate from './GameEngines/MpRotate/MpRotateV2';
import MpPuzzle from './GameEngines/MpPuzzle/MpPuzzleV2';
import MpClock from './GameEngines/MpClock/MpClockV2';
import MpConnect from './GameEngines/MpConnect/MpConnectV2';
import MpConnectMultiPoint from './GameEngines/MpConnect/MpConnectMultiPointV2';
import MpSorting from './GameEngines/MpSorting/MpSortingV2';
import TrSelectGame from './GameEngines/SelectGame/TrSelectGameV2';
import TrTextAreaOnBackground from './GameEngines/TextAreaOnBackground/TrTextAreaOnBackgroundV2';
import TrSelectGameWithTextImpr from './GameEngines/SelectGame/TrSelectGameWithTextImprV2';
import TrStepByStep from './GameEngines/StepByStep/TrStepByStepV2';
import TrStepByStepComics from './GameEngines/StepByStep/TrStepByStepComicsV2';
export default {
  name: 'tr-game-v2',
  props: [],
  components: {
    TrUiTitle,
    TrGameBody,
    TrGameControlPanel,
    TrGameStatus,
    TrTestMulti,
    TrTestMultiCheckboxImpr,
    TrTestMultiCheckbox,
    TrTestBoolean,
    TrTextBlockWithInput,
    TrInputOnBackground,
    TrInputOnBackgroundGeoDemo5,
    TrTestSelectGame,
    TrSelectGameWithText,
    MpFindWords,
    MpFindWords2,
    MpModelShow,
    MpTextSelect,
    MpChooseAnswer,
    MpCrossword,
    MpCrossword2,
    MpMillionaires,
    MpDraw,
    MpDraw2,
    MpDraw3,
    MpDraw13,
    MpMendelejew,
    MpCompare,
    MpDnD,
    MpDndFree,
    MpDndFree2,
    MpSortable,
    MpSortableMulti,
    MpRotate,
    MpPuzzle,
    MpClock,
    MpConnect,
    MpConnectMultiPoint,
    MpSorting,
    TrSelectGame,
    TrMultiCheckboxImpr,
    TrTextBlockWithInputImpr,
    TrTextAreaOnBackground,
    TrSelectGameWithTextImpr,
    TrStepByStep,
    TrStepByStepComics,
  },
  mounted() {
    let currentWindow = this.$electron.remote.getCurrentWindow();
    let $innerWindow = $('.game-scaleable-wrapper');
    let $el = $('.game-very-specific-design');
    let elHeight = $el.outerHeight();
    let elWidth = $el.outerWidth();

    function doResize(event, ui) {
      // // console.log( 'Resize' );
      let scale, origin;
      scale = Math.min($innerWindow.width() / elWidth, $innerWindow.height() / elHeight);
      // this.$store
      $el.css({
        transform: 'translate(-50%, -50%) ' + 'scale(' + scale + ')',
        '-webkit-transform-origin': 'center center',
        '-webkit-font-smoothing': 'subpixel-antialiased',
        'backface-visibility': 'hidden',
        // '-webkit-filter': 'blur(.0px)',
        // '-webkit-filter': scale,
        // transform: translateZ( 0 ),
      });
    }
    let resize = doResize.bind(this);
    let starterData = {
      size: {
        width: $innerWindow.width(),
        height: $innerWindow.height(),
      },
    };
    resize(null, starterData);
    currentWindow.on('resize', resize);
    if (this.gameConfig.withoutCheck) {
      this.$store.dispatch('disablingCheckAction');
    }
  },
  methods: {
    closeGame() {
      const gamesRouterPaths = ['game', 'gameV2', 'gameV4'];
      this.$store.dispatch('closeGame');
      // // console.log('this', this);
      if (
        this.prevRoute &&
        (this.prevRoute.name == 'songs-view' ||
          this.prevRoute.name == 'games-grid-view' ||
          this.prevRoute.name == 'one-unit-grid-view' ||
          this.prevRoute.name == 'revise-grid-view' ||
          this.prevRoute.name == 'plakaty-grid-view')
      ) {
        this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params });
      } else {
        if (gamesRouterPaths.includes(this.$route.name)) {
          let actualPage = `${parseInt(this.$store.getters[`${this.correctModuleName}/getActualPage`]?.id)}`;
          console.log('actualPage', actualPage);
          if (actualPage) {
            this.$router.push(`/page/${actualPage * 2 - 1}`);
          } else {
            this.$router.push(`/`);
          }
        }
      }
    },
    resetGameAction() {
      this.containerEnd = _.cloneDeep(config.containerEnd);
      this.containerStart = _.cloneDeep(config.containerStart);
      this.correctList = _.cloneDeep(config.correctList);
    },
    setVerySpecyficDesginStyle() {
      return {
        width: `${this.mainContenWidth}px`,
        height: `${this.mainContenHeight}px`,
        transform: `translate(-50%, -50%) scale(${this.scale})`,
      };
    },
    // /**
    //  * game engine selector
    //  * @method gameEngin
    //  * @param  {String}  type enginType
    //  * @return {Boolean}       if type is equal to engine in gameData return true
    //  */
    // gameEngin(type) {
    //   return this.gameData.item.engine === type;
    // }
  },
  computed: {
    componentEngine() {
      let typeTr = this.gameData.item.engine.replace(/^\w{0,1}/, function (a) {
        return 'Tr' + a.toUpperCase();
      });
      let typeMp = this.gameData.item.engine.replace(/^\w{0,1}/, function (a) {
        return 'Mp' + a.toUpperCase();
      });
      // console.log('this.gameData.item.author', this.gameData.item.author);
      return this.gameData.item.author != 'MP' ? typeTr : typeMp;
    },
    mainContenWidth() {
      return 1920 || this.$store.getters.mainContenWidth;
    },
    mainContenHeight() {
      return 1080 || this.$store.getters.mainContenHeight;
    },
    scale() {
      return this.$store.getters.scale || 1;
    },
    gameData() {
      return this.$store.getters.gameData;
    },
    /**
     * get game confioguration data-key
     * @method gameConfig
     * @return {Object}   configuration objec
     */
    gameConfig() {
      return _.cloneDeep(this.gameData.item.gameConfig);
    },
    assets() {
      return _.cloneDeep(this.gameData.item.assets);
    },
    actualGameStatus() {
      return this.$store.getters.actualGameStatus;
    },
  },
  // watch: {
  //   gameData: {
  //     handler: _.debounce(function (gameData) {
  //       this.$store.commit('CHANGE_GAME_CONTENT', gameData);
  //     }, 500),
  //     deep: true
  //   }
  // }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
.game-container {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // width: 100vw;
  // height: 100vh;
}
.game-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  .game-body {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
  }
  .freePosition {
    display: flex;
    position: absolute;
  }
}
.game-scaleable-wrapper {
  resize: both;
  position: relative;
  background: $offScaleColor;
  height: calc(var(--vh, 1vh) * 100);
  z-index: 8;
  overflow-y: hidden;
  overflow-x: hidden;
  .game-very-specific-design {
    width: 1920px;
    height: 1080px;
    text-align: center;
    background: $gamebackgroundColor;
    position: relative;
    left: 50%;
    top: 50%;
    transform-origin: center center 0;
  }
}

.close-button {
  pointer-events: auto;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 1;
  z-index: 1003;
  cursor: pointer;
  outline: none;
  border: none;
  background-color: $backgroundControlPanelColor;
  margin-right: 12px;
  margin-top: 22px;
  border-radius: 50%;
  // top: -47px !important;
  // right: -50px !important;
  display: flex;
  transform: scale(1);
  padding: 0;
  svg {
    path:first-child {
      fill: $bacgroundColor;
      // transform: scale(0.8);
      transition: all 0.4s ease;
    }
  }
  &:hover {
    svg {
      path:first-child {
        fill: $closeActiveColor;
        transition: all 0.4s ease;
      }
    }
    // background-color: $borderColor;
    // transform: scale(1.1);
    transition: all 0.4s ease;
    // opacity: 1;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.test-button {
  display: flex;
  width: 20%;
  height: 5%;
  position: absolute;
  top: 92%;
  left: 58%;
  font-size: 30px;
  .test-button-text {
    width: 100%;
    // border-radius: 10px;
  }
}
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-very-specific-design {
  top: 0 !important;
  left: 0 !important;
  // width: 1366px !important;
  // height: 768px !important;
  transform: translate(0%, 0%) scale(1) !important;
  transform-origin: center center 0;
  -webkit-font-smoothing: subpixel-antialiased;
  backface-visibility: hidden;
  .close-button {
    right: 26% !important;
    transform: translate(-50%, -50%) scale(0.7) !important;
  }
}
// .hack-game-cotrol-panel,
// .hack-game-status,
// .hack-game-title-wrapper {
//     transform: translate(-50%, -50%) scale(0.7)!important;
//     left: 32.5% !important;
//     top: 2% !important;
// }
//
// .hack-game-status {
//     left: 58.5% !important;
//     top: 66.8% !important;
// }
// .hack-game-cotrol-panel {
//     left: 67.5% !important;
//     top: 68.5% !important;
// }
</style>
